<style scoped>
    .text-remark {
        margin: 0px;
    }
    .hover-style {
        cursor: pointer;
    }
</style>
<template>
  <span
    class="text-center"
    style="display:inline"
  >
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          class="hover-style"
          size="20"
          color="primary"
          v-bind="attrs"
          v-on="on"
        >
          {{ icon }}
        </v-icon>
      </template>
      <p class="text-remark">
        {{ content }}
      </p>
    </v-tooltip>
  </span>
</template>
<script>
  export default {
    props: {
      content: {
        type: String
      },
      icon: {
        type: String,
        default: 'mdi-help-circle-outline'
      }
    }
  }
</script>
